import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://crm-backoffice.connvisor.com/wp-json/leads/v1", // WordPress REST namespace
  //baseURL: "http://localhost/leads-backoffice/wp-json/leads/v1",
  withCredentials: false, // Include cookies (for logged-in user)
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    console.log("request", config);
    const token = localStorage.getItem("crm_jwt_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("crm_jwt_token");

      sessionStorage.removeItem("crm_jwt_token");

      // Hard redirect keeps state clean
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default axiosInstance;
